import React from 'react';

const AuthUserContext = React.createContext({
  authUser: null,
  authHasConnected: false,
  setRefreshedUser: () => {},
});

export default AuthUserContext;
